import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Switch, Redirect } from 'react-router-dom';
import { PrivateRoute } from '@Components/';
import { Box, Tab, Tabs } from '@curves/ui-base';
import { EMPLOYEE_MEASURE_RESULT_ROUTER, EMPLOYEE_MEASURE_ROUTER } from "@Router/routerPath";
import { MeasurementProvider } from "@Local/Measurement/Context/MeasurementContext";
import { MeasurementDateController } from "@Local/Measurement/Components/Common";
import { MeasurementResultsPage } from "@Local/Measurement/index";
import { FOOTER_TYPE, HEADER_TYPE, THEME_TYPE } from "@Constants/";
import { useMainLayoutContext } from "@Local/Components/Layout/Context/MainLaydoutContext";

const EmployeeMeasurementPage = (props) => {
    const [measureID, setMeasureID] = useState(0);
    const pathname = props.location.pathname;
    const dialogRef = useRef(null);

    const { setHeaderType, setFooterType, setThemeType } = useMainLayoutContext();

    useEffect(
        () => {
            setHeaderType(HEADER_TYPE.LOGO_WHITE | HEADER_TYPE.HIDE_BACKGROUND | HEADER_TYPE.UNFIXED);
            setFooterType(FOOTER_TYPE.HIDE);
            setThemeType(THEME_TYPE.DARK);
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <MeasurementProvider value={{ measureID, setMeasureID, dialogRef }}>
            <Box className={'container p-2'}>
                <MeasurementDateController setMeasureID={setMeasureID} />
            </Box>
            <Box className={'measurement-menu'}>
                <Tabs value={pathname} className={'measurement-menu--container'}>
                    <Tab label={'量身結果'} value={EMPLOYEE_MEASURE_RESULT_ROUTER} component={NavLink} to={EMPLOYEE_MEASURE_RESULT_ROUTER} />
                </Tabs>
            </Box>
            <Switch>
                <PrivateRoute path={EMPLOYEE_MEASURE_RESULT_ROUTER} as={MeasurementResultsPage} exact />
                <Redirect from={EMPLOYEE_MEASURE_ROUTER} to={EMPLOYEE_MEASURE_RESULT_ROUTER} exact />
            </Switch>
        </MeasurementProvider>
    )
};

export default EmployeeMeasurementPage;